<template>
  <v-tooltip color="blue-grey darken-1" :max-width="width" :close-delay="closeDelay" bottom>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" @click.stop="">
        mdi-help-circle-outline
      </v-icon>
    </template>
    <span class="subheading" v-html="msg ? msg : $t('help.' + i18n)"></span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'callpanel-tooltip',
  data () {
    return {
      width: 400,
      closeDelay: 500
    }
  },
  props: {
    msg: { // message to display without any tranformations
      type: String
    },
    i18n: { // localization key relative to 'help.'
      type: String
    }
  }
}
</script>
<style scoped>
</style>
